import React, { useDebugValue, useEffect, useState } from "react";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchLanguage } from "../../redux/actions/LanguageAction";
import { useNavigate } from "react-router-dom";

const UpdateCandidateProfile = () => {
	const navigate = useNavigate();
	const sessionId = localStorage.getItem("sessionId");
	const userUID = localStorage.getItem("userUID");
	const [email, setEmail] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	console.log("userUID", userUID);

	// ...............................Gender DDL.......................................

	const [genderValue, setGenderValue] = useState(null);
	const dispatch = useDispatch();
	const { genderOptions, selectedGender } = useSelector(
		(state) => state.gender
	);
	useEffect(() => {
		dispatch(fetchGenders());
	}, [dispatch]);
	const handleGenderSelect = (selectedOption) => {
		if (selectedOption) {
			setGenderValue(selectedOption.value);
		} else {
			setGenderValue(null);
		}
	};
	// ...............................Gender DDL.......................................

	// ...............................language DDL.......................................

	const [langValue, setLangValue] = useState("");
	const { LanguageList, selectedLanguageId } = useSelector(
		(state) => state.language
	);

	useEffect(() => {
		dispatch(fetchLanguage());
	}, [dispatch]);

	const handleLanguageSelect = (selectedOption) => {
		if (selectedOption) {
			setLangValue(selectedOption.value);
		} else {
			setLangValue(null);
		}

	};
	// ...............................language DDL.......................................

	// ...............................City DDL.......................................
	const [cityId, setcityId] = useState("");
	const { cityList, selectedcityId } = useSelector((state) => state.cities);
	useEffect(() => {
		dispatch(fetchCityData());
		return () => {
			dispatch(clearCityList())
		}
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		console.log("Check Input value candidate==>", inputValue)
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityId(selectedOption.value);
		} else {
			setcityId(null);
		}

	};

	// ...............................City DDL.......................................

	// ...............................PROFILE Start.......................................
	const [displays, setDisplays] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [profileImage, setProfileImage] = useState();
	const [profileImageview, setProfileImageview] = useState("");
	const [error, setError] = useState(null);


	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// Validate file size (limit to 2MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageview(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};

	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};

	const Profile = async (e) => {
		e.preventDefault();
		try {
			setDisplays(true);
			console.log("Session ID:", sessionId);
			setIsSubmitting(true); // Disable the button during submission
			if (
				firstName&&
				lastName&&
				langValue &&
				genderValue &&
				cityId &&
				startDate &&
				profileImage !== ""
			) {
				const formData = new FormData();
				formData.append("LangId", langValue);
				formData.append("GenderId", genderValue);
				formData.append("CityId", cityId);
				formData.append("Dob", startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"));
				// formData.append("ProfileImage", profileImage);
				if (profileImage instanceof File) {
					formData.append("ProfileImage", profileImage);
				} else if (profileData?.profileImage) {
					formData.append("ProfileImage", profileData.profileImage);
				}
				formData.append("FirstName", firstName);
				formData.append("LastName", lastName);
				formData.append("Email", email);
				formData.append("SessionId", sessionId);
				const res = await axios.post(
					"/Account/UpdateCandidateProfile",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				console.log("candidate data", res);
				// navigate(`/Resume/Candidate?userUID=${userUID}`);

				toast.success(res.data.message);
				setDisplays(false);
				GetProfile();

			} else {
				toast.error("please enter required fields!");
				setIsSubmitting(false); // Re-enable the button if validation fails
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message);
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};
	console.log("Final Profile Image before API:", profileImage);

	// ...............................PROFILE End.......................................

	// ...............................Get PROFILE Start.......................................
	const [profileData, setProfileData] = useState("");
	const GetProfile = async () => {
		try {
			const res = await axios.get(`/Candidate/GetBasicProfile?UID=${userUID}`);
			console.log("==========>", res);

			setProfileData(res.data.responseData);
			const userData = res.data.responseData;
			localStorage.setItem("firstName", userData.firstName);
			localStorage.setItem("lastName", userData.lastName);
			localStorage.setItem("langName", userData.langName);
			localStorage.setItem("cityName", userData.cityName);
			localStorage.setItem("genderName", userData.genderName);
			localStorage.setItem("profilPic", userData.profileImage);
		} catch (error) {
			console.log("error", error);
		}
	};
	useEffect(() => {
		GetProfile();
	}, []);
	console.log("profileDatacan", profileData);

	useEffect(() => {
		if (profileData) {
			setGenderValue(profileData?.genderId);
			dispatch(selectGender(profileData?.genderId));
			setFirstName(profileData?.firstName);
			setLastName(profileData?.lastName);
			setEmail(profileData?.email)
			setLangValue(profileData?.langId);
			setcityId(profileData?.cityId);
			dispatch(selectCity(profileData?.cityId));
			setStartDate(profileData?.dob);
			setProfileImageview(profileData?.profileImage);
			//setProfileImage(profileData?.profileImage)
			dispatch(fetchCityData(profileData?.cityName));
			if (!profileImage && profileData?.profileImage) {
				fetch(profileData.profileImage)
					.then(response => response.blob())
					.then(blob => {
						const file = new File([blob], profileData.profileImage.split('/').pop(), { type: blob.type });
						setProfileImage(file);
					})
					.catch(error => console.error("Error fetching image:", error));
			}
		}
	}, [profileData]);


	// ...............................Get PROFILE End.......................................
	return (
		<>
			<section className="account-section pt-1">
				{/* <h6 className="f-600" >Profile Setting</h6> */}
				<div className="profile-setting-form">
					<div className="form-row">
						<div className="post-form-group text-transform-email  email-label-category">
							<label htmlFor="category">
								Email
							</label>
							<input
								type="email"
								id="tag"
								placeholder="Email"
								// onChange={(e) => setEmail(e.target.value)}
								onChange={(e) => setEmail(e.target.value)}
								value={email}
								invalid={displays && email === ""}
								className="Normal-Input-Fill"
								disabled
							/>
							{displays && !email ? (
								<span className="error_msg_lbl text-red">Enter email </span>
							) : null}
						</div>

						<div className="post-form-group">
							<label>
								First name <span className="text-red">*</span>
							</label>
							<input
								type="text"
								placeholder="First Name"
								value={firstName}
								onChange={(e) => setFirstName(e.target.value)}
								id="email"
								name="email"
								className="Normal-Input-Fill"
								invalid={displays && firstName === ""}
							/>
							{displays && !firstName ? (
								<span className="error_msg_lbl text-red">
									Enter first name{" "}
								</span>
							) : null}
						</div>
					</div>
					<div className="form-row">
						<div className="post-form-group">
							<label>
								Last name <span className="text-red">*</span>
							</label>
							<input
								type="text"
								placeholder="Last Name"
								value={lastName}
								onChange={(e) => setLastName(e.target.value)}
								id="email"
								name="email"
								className="Normal-Input-Fill"
								invalid={displays && lastName === ""}
							/>
							{displays && !lastName ? (
								<span className="error_msg_lbl text-red">
									Enter last name{" "}
								</span>
							) : null}
						</div>
						<div className="form-group">
							<label htmlFor="Langauge">Language <span className="text-red">*</span></label>

							<ReactSelect
								options={LanguageList}
								// onChange={handleLanguageSelect}
								// onChange={(option) => handleFieldChange(setLangValue, option ? option.value : "")} // Track changes
								onChange={(option) => setLangValue(option ? option.value : "")} // Track changes
								value={
									LanguageList.find(
										(option) => option.value === langValue
									) || null
								}
								placeholder="Select Language"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
							/>
							{displays && !langValue ? (
								<span className="error_msg_lbl text-red">Select language </span>
							) : null}
						</div>
					</div>



					<div className="form-row">

						<div className="form-group">
							<label htmlFor="city">City <span className="text-red">*</span></label>
							<ReactSelect
								options={cityList}
								// onChange={(option) => handleFieldChange(setcityId, option ? option.value : "")} 
								onChange={(option) => setcityId(option ? option.value : "")} // Track changes

								value={
									cityList.find((option) => option.value === cityId) ||
									null
								}
								onInputChange={handleCityInputChange}
								placeholder="Search & Select City"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
							/>

							{displays && !cityId ? (
								<span className="error_msg_lbl text-red">Search & select city </span>
							) : null}
						</div>


						<div className="form-group">
							<label htmlFor="gender">Gender <span className="text-red">*</span></label>
							<ReactSelect
								options={genderOptions}
								// onChange={(option) => handleFieldChange(setGenderValue, option ? option.value : "")} // Track changes
								onChange={(option) => setGenderValue(option ? option.value : "")} // Track changes

								value={
									genderOptions.find(
										(option) => option.value === genderValue
									) || null
								}
								placeholder="Select Gender"
								styles={customStyles}
								classNamePrefix="react-select"
								className="form-control"
								isClearable
							/>
							{displays && !genderValue ? (
								<span className="error_msg_lbl text-red">Select gender </span>
							) : null}
						</div>
					</div>


					<div className="form-row">
						<div className="form-group">
							<label htmlFor="dob">DOB <span className="text-red">*</span></label>
							<Flatpickr
								type="number"
								id="dob"
								className="form-control Dark-Input-from-group"
								required
								// onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
								onChange={(date) => setStartDate(date[0])}
								value={startDate}
								options={{
									maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
								}}
								invalid={displays && startDate === ""}
							/>

							{displays && !startDate ? (
								<span className="error_msg_lbl text-red">Select DOB </span>
							) : null}
						</div>

						<div className="form-group">
							<label htmlFor="ProfileImg">Profile image</label>
							<input
								type="file"
								id="ProfileImg"
								className="form-control Dark-Input-from-group"
								required
								accept="image/jpeg, image/png, image/jpg"
								onChange={(e) => {
									// handleFieldChange(setProfileImage, e.target.files[0]);
									setProfileImage(e.target.files[0]);
									setProfileImageview(URL.createObjectURL(e.target.files[0]));
								}}
							// style={{ height: '56px', paddingTop: '15px' }}
							/>

							{/* {error && <span className="error_msg_lbl text-red">{error}</span>}
							{!error && !profileImage && (
								<span className="error_msg_lbl text-red">Select an image</span>
							)} */}
							{profileImageview && (
								<div className="d-flex justify-content-center" style={{ width: '125px', height: '125px' }}>
									<img
										src={profileImageview}
										alt="Profile Preview"
										// width={75}
										// height={75}
										className="mt-2 rounded-circle"
									// style={{ borderRadius: '50%' }}
									/>

								</div>

							)}
						</div>

					</div>

					<div className="form-group">
					</div>

					<button
						//  className="btn btn-primary"
						onClick={Profile}
						className="btn btn-primary"
					>
						Update
					</button>
				</div>
			</section>
		</>
	);
};

export default UpdateCandidateProfile;
